import _taggedTemplateLiteral from "/home/alex/code/avail/ny-mitigates/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n\t\tpadding: 1rem;\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n\tflex: 1 1 1%;\n\t", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["padding-", ": calc(", " + 1rem)"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\t\t", ";\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tdisplay: flex;\n\tpadding: 0.5rem 0.5rem 2.5rem;\n\t", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { light } from '@stickyroll/themes';
/**
 * This component can be used to add a themed inner wrapper. This is especially helpful when using
 * nested stickyroll components (e.g. Pagers).
 *
 * The theme is inherited and can therefore be used in other components. This mechanism relies on
 * styled-components `ThemeProvider`
 * ### Usage:
 * ```jsx
 * import {Stickyroll} from "@stickyroll/stickyroll";
 * import {Inner} from "@stickyroll/inner";
 * const App = () => (
 *   <Stickyroll pages={1}>
 *       {() => <Inner/>}
 *   </Frame>
 * )
 * ```
 * ---
 * @type {StyledComponent<"section", ITheme, IInnerProps>}
 * @param {IInnerProps} props
 * @param {ITheme} [props.theme]
 * @param {boolean} [props.withPagers]
 * @return {React.ReactHTMLElement<HTMLElement>}
 */

var Inner = styled.section(_templateObject(), function (props) {
  return css(_templateObject2(), props.withPagers && css(_templateObject3(), props.withPagers, props.theme.pagerSize), props.theme.color, props.theme.backgroundColor);
});
Inner.defaultProps = {
  theme: light
};
var Content = styled.div(_templateObject4(), function (props) {
  return css(_templateObject5(), props.theme.color, props.theme.backgroundColor);
});
Content.defaultProps = {
  theme: light
};
export { Inner, Content };